import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Plus, Pencil, Trash2, Star } from "lucide-react";
import { toast } from "sonner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { http, imgUrl, articlePath, catName, timeAgo, apiError } from "@/lib/api";
import { AdminShell } from "./AdminShell";
import { AdsManager } from "./AdsManager";

function PostsList() {
  const [posts, setPosts] = useState(null);
  const load = () => http.get("/admin/posts").then((r) => setPosts(r.data));
  useEffect(() => { load(); }, []);
  const del = async (p) => {
    if (!window.confirm(`Apagar "${p.title}"?`)) return;
    try { await http.delete(`/admin/posts/${p.id}`); toast.success("Publicação apagada"); load(); } catch (e) { toast.error(apiError(e)); }
  };
  if (!posts) return <p className="text-muted-foreground">A carregar…</p>;
  if (!posts.length) return <p data-testid="admin-posts-empty" className="rounded-xl border border-dashed bg-background p-10 text-center text-muted-foreground">Ainda não tem publicações. Clique em "Nova publicação".</p>;
  return (
    <div data-testid="admin-posts-list" className="divide-y rounded-xl border bg-background">
      {posts.map((p) => (
        <div key={p.id} className="flex items-center gap-4 p-4" data-testid={`admin-post-${p.id}`}>
          <img src={imgUrl(p.id, 320)} alt="" className="aspect-video w-32 shrink-0 rounded-md object-cover" />
          <div className="min-w-0 flex-1">
            <p className="font-mono-meta text-[10px] font-bold uppercase text-primary">{catName(p.category)} · {timeAgo(p.date)} · {p.views || 0} leituras {p.featured && <Star size={10} className="inline fill-amber-500 text-amber-500" />}</p>
            <Link to={articlePath(p)} className="font-serif-display font-bold leading-snug hover:text-primary line-clamp-2">{p.title}</Link>
          </div>
          <Link to={`/admin/editar/${p.id}`} data-testid={`admin-edit-${p.id}`} className="grid h-9 w-9 place-items-center rounded-full hover:bg-muted" aria-label="Editar"><Pencil size={16} /></Link>
          <button onClick={() => del(p)} data-testid={`admin-delete-${p.id}`} className="grid h-9 w-9 place-items-center rounded-full text-primary hover:bg-primary/10" aria-label="Apagar"><Trash2 size={16} /></button>
        </div>
      ))}
    </div>
  );
}

export default function AdminDashboard() {
  return (
    <AdminShell>
      <div className="mb-6 flex flex-wrap items-center justify-between gap-4">
        <h1 className="font-serif-display text-3xl font-black">Painel</h1>
        <Link to="/admin/nova" data-testid="admin-new-post-btn" className="flex items-center gap-2 rounded-full bg-primary px-5 py-2.5 text-sm font-bold text-white"><Plus size={16} />Nova publicação</Link>
      </div>
      <Tabs defaultValue="posts">
        <TabsList className="mb-6">
          <TabsTrigger value="posts" data-testid="admin-tab-posts">As minhas publicações</TabsTrigger>
          <TabsTrigger value="ads" data-testid="admin-tab-ads">Anúncios</TabsTrigger>
        </TabsList>
        <TabsContent value="posts"><PostsList /></TabsContent>
        <TabsContent value="ads"><AdsManager /></TabsContent>
      </Tabs>
    </AdminShell>
  );
}
